import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { dramas } from "@/mocks/dramas";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import CategorySection from "./components/CategorySection";
import NewsSection from "./components/NewsSection";
import RankingSection from "./components/RankingSection";
import AboutBand from "./components/AboutBand";
import FaqSection, { homeFaqs } from "./components/FaqSection";

const SITE_URL = "https://beesfly.cn";

export default function Home() {
  useSeo({
    title: "短剧爆料社 — 短剧演员表查询、导演编剧信息与拍摄花絮",
    description:
      "想查爆料短剧的演员表查询、导演编剧信息，这里都给你列全。拍摄花絮与幕后制作故事揭秘镜头背后的操作，剧集口碑评分帮你判断值不值得追。",
    keywords: "爆料短剧,演员表查询,导演编剧信息,拍摄花絮,幕后制作故事,剧集口碑评分",
    path: "/",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20cinematic%20background%20of%20a%20vintage%20movie%20theatre%20with%20deep%20crimson%20velvet%20curtains%2C%20warm%20golden%20spotlight%20beams%2C%20blurred%20bokeh%20lights%2C%20moody%20dramatic%20atmosphere%2C%20rich%20textured%20fabric%2C%20editorial%20photography&width=1800&height=1000&seq=duanju-hero-main&orientation=landscape",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "短剧爆料社",
        url: SITE_URL,
        description: "整理爆料短剧的演员表、导演编剧信息、拍摄花絮与剧集口碑评分。",
        email: "hello@duanju-insider.example.com",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "本周热播爆料短剧",
        itemListElement: dramas.slice(0, 4).map((drama, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `${SITE_URL}/drama/${drama.id}`,
          name: drama.title,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <TrendingSection />
      <CategorySection />
      <NewsSection />
      <RankingSection />
      <AboutBand />
      <FaqSection />
    </SiteLayout>
  );
}